export enum SoundId {
	SHOT = "SHOT",
	SHOT_SOLIDIFIER = "SHOT_SOLIDIFIER",
	SHOT_MISSILE = "SHOT_MISSILE",
	SHOT_PLASMAGUN = "SHOT_PLASMAGUN",
	SHOT_THROW = "SHOT_THROW",
	SOLIDIFYING = "SOLIDIFYING",
	SOLIDIFIED_MOB_EMERGE = "SOLIDIFIED_MOB_EMERGE",
	ZOOM = "ZOOM",
	PICKUP_BOX = "PICKUP_BOX",
	PICKUP_GOLD = "PICKUP_GOLD",
	ROCK_BREAK = "ROCK_BREAK",
	LASER_BEAM = "LASER_BEAM",
	EXPLOSION = "EXPLOSION",
	EXPLOSION_SHOCK = "EXPLOSION_SHOCK",
	BIG_EXPLOSION = "BIG_EXPLOSION",
	HEALING_SPRAY = "HEALING_SPRAY",
	METAL_BANG = "METAL_BANG",
	BIG_CONTAINER_OPEN = "BIG_CONTAINER_OPEN",
	GORE_SPLAT = "GORE_SPLAT",
	FLAMETROWER_LAUNCH = "FLAMETROWER_LAUNCH",
	FLAME_BURNING = "FLAME_BURNING",
	LANDMINE_DEPLOY = "LANDMINE_DEPLOY",
	DRILL_RUNNING = "DRILL_RUNNING",
	GAS_RELEASE = "GAS_RELEASE",
	GAS_RELEASE_BOSS = "GAS_RELEASE_BOSS",
	PLAYER_HURT = "PLAYER_HURT",
	MOB_PHISICAL_ATTACK = "MOB_PHISICAL_ATTACK",
	SQUID_SOUND = "SQUID_SOUND",
	HORNED_SOUND = "HORNED_SOUND",
	MANDIBLE_MOVEMENT = "MANDIBLE_MOVEMENT",
	TERMINAL_CONFIRM = "TERMINAL_CONFIRM",
	TERMINAL_ERROR = "TERMINAL_ERROR",
	BLAST_DOOR_OPEN = "BLAST_DOOR_OPEN",
	SLIDING_DOOR_OPEN = "SLIDING_DOOR_OPEN",
	DRILL_SINGLE_RUN = "DRILL_SINGLE_RUN",
	ROBOT_SWORD_ACTIVATE = "ROBOT_SWORD_ACTIVATE",
	ROBOT_SOUND = "ROBOT_SOUND",
	ROBOT_POWER_ON = "ROBOT_POWER_ON",
	ROBOT_TARGET_ACQUIRED = "ROBOT_TARGET_ACQUIRED",
	ROBOT_DIE = "ROBOT_DIE",
	ARTILLERY_AIMING_STAGE_1 = "ARTILLERY_AIMING_STAGE_1",
	ARTILLERY_AIMING_STAGE_2 = "ARTILLERY_AIMING_STAGE_2",
	ARTILLERY_SIMPLE_BEEP = "ARTILLERY_SIMPLE_BEEP",
	ROBOT_BASE_ALARM = "ROBOT_BASE_ALARM",
	MANDIBLE_DIE = "MANDIBLE_DIE",
	BIG_SQUID_SOUND = "BIG_SQUID_SOUND",
	BIG_SQUID_DIE = "BIG_SQUID_DIE",
	BITER_DIE = "BITER_DIE",
	SQUID_DIE = "SQUID_DIE",
	HORNED_DIE = "HORNED_DIE",
	CAMERA = "CAMERA",
	ROBOT_BIG_TARGET_ACQUIRED = "ROBOT_BIG_TARGET_ACQUIRED",
	ROBOT_BIG_DIE = "ROBOT_BIG_DIE",
	NIGHT_VISION_TOGGLE = "NIGHT_VISION_TOGGLE",
	POWER_PLANT_SWITCH_ACTIVATE = "POWER_PLANT_SWITCH_ACTIVATE",
	JETPACK_THRUST = "JETPACK_THRUST",
	SWORD_LUNGE = "SWORD_LUNGE",
	SWORD_SLASH = "SWORD_SLASH",
	SWORD_JAB = "SWORD_JAB",
	CLEAVER_ATTACK = "CLEAVER_ATTACK",
	TOXIC_SLUG_DIE = "TOXIC_SLUG_DIE",
	TOXIC_SLUG_ATTACK = "TOXIC_SLUG_ATTACK",
}
